import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useTypedParams } from '@sorare/routing';

import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import { LineupSharing } from '@sorare/gameplay/src/components/lineup/LineupSharing';
import { So5Lineup } from '@sorare/gameplay/src/components/lineup/So5Lineup';

import field from 'components/lineup/LineupLayout/assets/field.webp';

import type {
  MLBLineupSharingQuery,
  MLBLineupSharingQueryVariables,
} from './__generated__/page.graphql';
import type { PageParams } from './__generated__/routeParams';

const MLB_LINEUP_SHARING_QUERY = gql`
  query MLBLineupSharingQuery($id: ID!) {
    so5 {
      so5Lineup(id: $id) {
        id
        so5LeaderboardContender {
          slug
          ...So5Lineup_so5LeaderboardContender
        }
        ...LineupSharing_so5Lineup
      }
    }
  }
  ${So5Lineup.fragments.so5LeaderboardContender}
  ${LineupSharing.fragments.so5Lineup}
` as TypedDocumentNode<MLBLineupSharingQuery, MLBLineupSharingQueryVariables>;

const MLBLineupSharing = () => {
  const { id } = useTypedParams<PageParams>();
  const { data } = useQuery(MLB_LINEUP_SHARING_QUERY, {
    variables: {
      id,
    },
  });

  const { so5Lineup } = data?.so5 || {};
  const { so5LeaderboardContender } = so5Lineup || {};
  if (!so5Lineup || !so5LeaderboardContender) return null;

  return (
    <LineupSharing
      so5Lineup={so5Lineup}
      so5LineupNode={
        <So5Lineup
          so5LeaderboardContender={so5LeaderboardContender}
          lineupStyle="spread"
        />
      }
      field={field}
    />
  );
};

export default MLBLineupSharing;
